import { 
    page, 
    detail,
    syncData
} from '@/api/ad-settlement.js'

export default {
  state: {
    list: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    adSettlementLoading: false
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setAdSettlementLoading (state, loading) {
      state.adSettlementLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    adSettlementList: state => state.list,
    adSettlementTotal: state => state.total,
    adSettlementLoading: state => state.adSettlementLoading
  },
  actions: {
    getAdSettlementPage ({ state, commit }, param) {
      commit('setAdSettlementLoading', true)
      return new Promise((resolve, reject) => {
        page(param).then(res => {
          const data = res.data.result
          const list = data.records
          const total = data.total
          const pageNum = data.pageNum
          const pageSize = data.pageSize
          commit('setList', list)
          commit('setTotal', total)
          commit('setPageNum', pageNum)
          commit('setPageSize', pageSize)
          commit('setAdSettlementLoading', false)
          resolve()
        }).catch(err => {
          commit('setAdSettlementLoading', false)
          reject(err)
        })
      })
    },
    getAdSettlementDetail ({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        detail(param).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    syncAdSettlementData({ state, commit }) {
      return new Promise((resolve, reject) => {
        syncData().then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/ad-settlement.js